"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const USStateRegionMapping = {
    Alaska: 'West',
    California: 'West',
    Hawaii: 'West',
    Idaho: 'West',
    Nevada: 'West',
    Oregon: 'West',
    Washington: 'West',
    Arizona: 'Southwest',
    Colorado: 'Southwest',
    'New Mexico': 'Southwest',
    Oklahoma: 'Southwest',
    Texas: 'Southwest',
    Utah: 'Southwest',
    Wyoming: 'Southwest',
    Alabama: 'Southeast',
    Arkansas: 'Southeast',
    Florida: 'Southeast',
    Georgia: 'Southeast',
    Kentucky: 'Southeast',
    Louisiana: 'Southeast',
    Mississippi: 'Southeast',
    Montana: 'West',
    'North Carolina': 'Southeast',
    'South Carolina': 'Southeast',
    Tennessee: 'Southeast',
    Virginia: 'Southeast',
    'West Virginia': 'Southeast',
    Connecticut: 'Northeast',
    Maine: 'Northeast',
    Massachusetts: 'Northeast',
    'New Hampshire': 'Northeast',
    'Rhode Island': 'Northeast',
    Vermont: 'Northeast',
    Illinois: 'Midwest',
    Indiana: 'Midwest',
    Iowa: 'Midwest',
    Kansas: 'Midwest',
    Michigan: 'Midwest',
    Minnesota: 'Midwest',
    Missouri: 'Midwest',
    Nebraska: 'Midwest',
    'North Dakota': 'Midwest',
    Ohio: 'Midwest',
    'South Dakota': 'Midwest',
    Wisconsin: 'Midwest',
    Delaware: 'Mid-Atlantic',
    Maryland: 'Mid-Atlantic',
    'New Jersey': 'Mid-Atlantic',
    'New York': 'Northeast',
    Pennsylvania: 'Mid-Atlantic',
};
exports.default = USStateRegionMapping;
